import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useConfig } from '@app/config';
import { gql, request } from 'graphql-request';
import { NFTMarketplaceBid } from '@app/types/nftMarketplace';

async function fetcher(listingId: string, apiUrl: string | undefined) {
  if (!apiUrl) {
    return null;
  }

  const res = await request<{ bids: NFTMarketplaceBid[] }>(
    `${apiUrl}`,
    gql`
      query {
        bids(where: { listing: "${listingId}", isActive: true }) {
          id
        }
      }
    `
  );

  return res.bids.length > 0;
}

export function useHasActiveBids(listingId: string) {
  const config = useConfig();

  return useQuery<boolean | null>(
    [
      QueryKeys.GET_HAS_ACTIVE_OFFERS,
      listingId,
      config?.URLS.subgraphUrlNftMarketplace
    ],
    () => fetcher(listingId, config?.URLS.subgraphUrlNftMarketplace),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false
    }
  );
}
